import { fork, call, put, takeLatest } from 'redux-saga/effects';

import { sendLog, LoggerStatusEnum } from 'ui-model';

import request from 'utils/request';
import { LOAD_TYPE } from './constants';
import { loadTypeSuccess } from './actions';

const DEFAULT_TYPE = 'sms';

export function* onWatchLoadType(action) {
  try {
    const { value } = action;
    let response;
    if (/@/.test(value)) {
      response = 'email';
    } else if (!value || value.replace(/\D/g, '').length < 10) {
      response = DEFAULT_TYPE;
    } else {
      const { type } = yield call(request, `/phoneNumbers/${value}`);
      if (type === 'landline') {
        response = 'voice';
      } else {
        // default
        response = DEFAULT_TYPE;
      }
    }
    yield put(loadTypeSuccess(response));
  } catch (err) {
    sendLog('Error on FieldContactTypeAutodetect saga', { errorStack: err, action }, LoggerStatusEnum.error);
    yield put(loadTypeSuccess(DEFAULT_TYPE));
  }
}

export function* watchLoadType() {
  yield takeLatest(LOAD_TYPE, onWatchLoadType);
}

export default function* sagas() {
  yield fork(watchLoadType);
}
